/** Descope `coapp-sign-in` flow — screen names must match Flow builder. */
export const FLOW_ID = import.meta.env.VITE_DESCOPE_LOGIN_FLOW_ID || "coapp-sign-in";

export const SCREEN = {
	ENTER_EMAIL: "Enter Email",
	ORG_PICKER: "Organization Picker Unused",
	POLLING: "Polling",
	POLLING_SUCCESS: "Polling Success"
} as const;

export type ByosScreenName = (typeof SCREEN)[keyof typeof SCREEN];

/** Interaction IDs — rename in Descope Console to match if flow differs. */
export const INTERACTION = {
	EMAIL_ENTERED: "email-entered",
	TENANT_SELECTED: "tenant-selected",
	/** Enchanted-link poll step — must match Flow builder interaction id. */
	POLL: "polling",
	RESEND_LINK: "resend",
} as const;

export const BYOS_SCREEN_NAMES = new Set<string>(Object.values(SCREEN));
